import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { ModalContext, ModalProvider } from '../../../context/ModalContext';
import UpdatePriceModal from '../../../sections/dashboard/warehouse/UpdatePriceModal';
import { formateDatimeStrToNiajaTime } from '../../../utils/utils';
import { HoverDropDown } from '../../DropDown/DropDown';
import HorizontalDot from '../../Icons/HorizontalDot';
import { Modal } from '../../Modal/Modal';

const IconContainer = () => {
  const modalContext = useContext(ModalContext);

  const createRackHandler = (e: any) => {
    modalContext?.displayModal(true);
  };
  return (
    <IconContainerWrapper
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
      }}
    >
      <HoverDropDown className="options" label={<HorizontalDot />}>
        <DropDownContent
          onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            createRackHandler(e);
            e.stopPropagation();
          }}
        >
          Update Price
        </DropDownContent>
      </HoverDropDown>
    </IconContainerWrapper>
  );
};

interface ILastUpdatedByComponent {
  children: string;
  tModalData: any;
}

const LastUpdatedByComponent: React.FC<ILastUpdatedByComponent> = ({
  children,
  tModalData,
}) => {
  // console.log('tModalData---->>>>', tModalData);
  return (
    <ModalProvider>
      <Container>
        {children && formateDatimeStrToNiajaTime(children)}
        <IconContainer />
      </Container>
      <Modal>
        <UpdatePriceModal priceId={tModalData.id} />
      </Modal>
    </ModalProvider>
  );
};

export default LastUpdatedByComponent;

const DropDownContent = styled.div`
  display: flex;
  padding: 1rem;
  width: 120px;

  &:hover {
    background-color: ${({ theme }) => theme.palette.brandBackdrop};
  }
`;

const Container = styled.div`
  display: flex;
  /* border: 2px solid red; */
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
`;

const IconContainerWrapper = styled.div`
  display: flex;
  /* border: 1px solid green; */
  padding: 0.25rem 0.5rem;
`;
